<template>
  <div class="row-data font-weight-regular">
    <span class="pl-3 card-grid-display font-weight-regular">{{ getCellData() }}</span>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  components: {},
  name: "AccountFrozenRowTemplate",
  props: {
    cell: {}, col: {}
  },
  methods: {
    getCellData() {
      return this.data[this.col] ?? '-';
    },
  }
};
</script>

<style></style>